export const MAIN_NAV = [
  { label: "Property Search", link: "/property-search" },
  {
    label: "Courses / Events",
    link: "https://info.libertyconnectnyc.com/courses-events",
  },
  { label: "Resources", link: "/resources" },
  { label: "Membership", link: "/membership" },
];
